<template>
  <div class="group-icon d-inline-block">
    <b-button :id="elementId" class="m-0 p-0 text-left" variant="link">
      <group-media :group="group" :group-link="true" :avatar-size="avatarSize" :show-slug="false" />
    </b-button>

    <group-popover v-if="!!group" :target="elementId" :group="group" :avatar-size="75" />
  </div>
</template>

<script>
  import { CaseGroupResource } from '@/api-resources';

  export default {
    name: 'GroupIcon',

    components: {
      GroupMedia: () => import('@/Molecules/GroupMedia'),
      GroupPopover: () => import('@/Molecules/GroupPopover'),
    },

    props: {
      group: CaseGroupResource,
      avatarSize: {
        type: Number,
        default: 40,
      },
    },

    computed: {
      elementId() {
        return `user-icon-${this._uid}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';
  ::v-deep {
    .media-body {
      h5,
      small a {
        white-space: normal;
      }
      small a {
        color: var(--gray-900);
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .btn {
    text-transform: none;
    text-decoration: none;
    color: var(--gray-900);
    font-size: 1rem;
    line-height: 1.2;
  }
</style>
